import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { User } from '@/types';

export interface AuthState {
  user: User;
  isAdmin: boolean;
  isAuthenticated: boolean;
  authorities: string[];
  /** True once the initial checkAuthentication has settled (so we know if user is logged in). */
  authChecked: boolean;
}

const initialState: AuthState = {
  user: {},
  isAdmin: false,
  isAuthenticated: false,
  authorities: [],
  authChecked: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<User>) {
      const payload = action.payload;
      const authorities = payload?.authorities?.map((a) => a.authority) ?? [];
      state.user = payload;
      state.authorities = authorities;
    },
    updateUser(state, action: PayloadAction<User>) {
      state.user = action.payload;
    },
    setIsAdmin(state, action: PayloadAction<boolean>) {
      state.isAdmin = action.payload;
    },
    setAuthenticated(state, action: PayloadAction<boolean>) {
      state.isAuthenticated = action.payload;
    },
    logout(state) {
      state.user = {};
      state.isAdmin = false;
      state.isAuthenticated = false;
      state.authorities = [];
    },
    setAuthChecked(state, action: PayloadAction<boolean>) {
      state.authChecked = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        (action) =>
          action.type === 'auth/check/fulfilled' || action.type === 'auth/check/rejected',
        (state) => {
          state.authChecked = true;
        }
      );
  },
});

export const { setUser, updateUser, setIsAdmin, setAuthenticated, logout, setAuthChecked } =
  authSlice.actions;
export default authSlice.reducer;
